import { render, staticRenderFns } from "./sc-field-boolean.vue?vue&type=template&id=a54435d2&scoped=true&"
import script from "./sc-field-boolean.vue?vue&type=script&lang=js&"
export * from "./sc-field-boolean.vue?vue&type=script&lang=js&"
import style0 from "./sc-field-boolean.vue?vue&type=style&index=0&id=a54435d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54435d2",
  null
  
)

export default component.exports